<template>
    <div id="thanks">
        <b-container class="thanks-container">
            <div class="thanks-wrapper">
                <b-col class="centerv">
                    <h1>THANK YOU!</h1>
                    <p class="mb-5">Your message was sent. We will get back to you as soon as possible.</p>
                    <router-link class="btn" :to="{ name: 'Home'}">Visit our website</router-link>
                </b-col>
            </div>
        </b-container>
    </div>
</template>

<script>
    export default {
        components: {
            
        }
    }
</script>

<style scoped>
#thanks{
    background: #F1EBE3;
}
.thanks-container{
    padding-top: 100px;
    padding-bottom: 50px;
    min-height: 100vh;
    display: grid;
}
.thanks-wrapper{
    display: flex;
    background: #CAAF8E0D;
    text-align: center;
    height: 100%;
    border-radius: 50px;
    padding: 10%;
}
h1{
    text-transform: uppercase;
    font-size: 150px;
    font-weight: 400;
}
p{
    font-size: 20px;
    font-weight: 300;
}
.btn{
    background: transparent;
    color: #503B2D;
    border: 1px solid #503B2D;
    text-transform: uppercase;
    border-radius: 20px;
    width: 220px;
}
.btn:hover,
.btn:focus,
.btn:active{
    background: transparent !important;
    color: #503B2D !important;
    border: 1px solid #503B2D !important;
}

@media (max-width: 992px){
    h1{
        font-size: 130px;
    }
}
@media (max-width: 768px){
    h1{
        font-size: 50px;
    }
    p{
        font-size: 20px;
    }
    .btn{
        font-size: 12px;
    }
}
</style>